import fillCrudMetadataGaps, { PartialField } from '../../fillCrudMetadataGaps';
import authorization from '../../util/authorization';
const SEARCH_CRITERIA: PartialField[] = [{
  label: 'Check-in',
  name: 'startDate',
  type: 'text',
  required: false
}, {
  label: 'Check-out',
  name: 'endDate',
  type: 'text',
  required: false
}, {
  label: 'Noites',
  name: 'nights',
  type: 'int',
  required: false
}, {
  label: 'Destinos',
  name: 'destinations',
  type: 'object',
  graphQLType: 'EmbeddedCriteriaDestinations',
  graphQLInputType: 'EmbeddedCriteriaDestinationsInput',
  default: {},
  required: false,
  fields: [{
    name: 'propertyId',
    type: 'text',
    required: false
  }, {
    name: 'contentType',
    type: 'text',
    required: false
  }, {
    name: 'cityIds',
    type: 'textarray',
    required: false
  }, {
    name: 'hotelIds',
    type: 'textarray',
    required: false
  }]
}, {
  label: 'Nome do destino',
  name: 'destinationName',
  type: 'text',
  required: false
}, {
  label: 'Quartos',
  name: 'rooms',
  type: 'objectarray',
  graphQLType: '[EmbeddedCriteriaRooms]',
  graphQLInputType: '[EmbeddedCriteriaRoomsInput]',
  default: null,
  required: false,
  fields: [{
    label: 'Adultos',
    name: 'adults',
    type: 'int',
    required: false
  }, {
    label: 'Crianças',
    name: 'children',
    type: 'int',
    required: false
  }, {
    label: 'Idade das crianças',
    name: 'childrenAges',
    type: 'intarray',
    required: false
  }]
}, {
  label: 'Código Promocional',
  name: 'promoCode',
  type: 'text',
  required: false
}];
export default fillCrudMetadataGaps({
  label: 'Campanha',
  labelPlural: 'Campanhas',
  name: 'PromotionalCampaign',
  namePlural: 'PromotionalCampaigns',
  authorization: authorization('consultant', 'admin'),
  deletable: false,
  dynamoDB: {
    tableName: 'SpearPromotionalCampaign'
  },
  columns: ['id', 'name', 'enabled'],
  fields: [{
    label: 'Id',
    name: 'id',
    type: 'text',
    updatable: false,
    insertable: false,
    id: true,
    renderColumn: false
  }, {
    name: 'name',
    label: 'Nome',
    type: 'text',
    required: true
  }, {
    name: 'enabled',
    label: 'Ativo',
    default: false,
    required: true,
    type: 'boolean'
  }, {
    name: 'startDate',
    label: 'Data de início',
    type: 'date'
  }, {
    name: 'endDate',
    label: 'Data de término',
    type: 'date'
  }, {
    label: 'Conteúdo',
    name: 'content',
    type: 'objectarray',
    inputType: 'InputObjectArray',
    default: [],
    fields: [{
      label: 'Título',
      name: 'title',
      type: 'text',
      required: true,
      maxLength: 36
    }, {
      label: 'Descrição',
      name: 'text',
      type: 'text',
      required: true,
      maxLength: 300
    }, {
      label: 'Imagem da campanha',
      name: 'image',
      type: 'text',
      required: true,
      inputType: 'inputPublicFile',
      hint: 'Imagem png ou jpeg com medida de 750 x 450px'
    }, {
      label: 'Texto do botão',
      name: 'button_text',
      type: 'text',
      required: false,
      maxLength: 30
    }, {
      label: 'Critério de busca',
      name: 'criteria',
      type: 'object',
      graphQLType: 'EmbeddedCriteria',
      graphQLInputType: 'EmbeddedCriteriaInput',
      default: {},
      required: false,
      fields: SEARCH_CRITERIA
    }, {
      label: 'Link do botão',
      name: 'button_link',
      type: 'text',
      required: false,
      hint: 'https://*.exemplo.com/*'
    }]
  }, {
    groupName: 'Banner de Pesquisa',
    name: 'search_banner',
    label: 'Banner de Pesquisa',
    default: [],
    type: 'objectarray',
    inputType: 'InputObjectArray',
    fields: [{
      label: 'Título do banner',
      name: 'name',
      type: 'text',
      required: true
    }, {
      label: 'Título',
      name: 'title',
      type: 'text',
      required: false,
      maxLength: 36
    }, {
      label: 'Descrição',
      name: 'text',
      type: 'text',
      required: false,
      maxLength: 300
    }, {
      label: 'Banner da campanha',
      name: 'image',
      type: 'text',
      inputType: 'inputPublicFile',
      required: true,
      hint: 'Imagem png ou jpeg com medida de 550 x 350px'
    }, {
      label: 'Adicionar overlay',
      name: 'overlay',
      type: 'boolean',
      required: false
    }]
  }],
  filter: [{
    name: 'enabled_eq',
    field: 'enabled',
    op: 'eq'
  }]
});